import type { PlcManufacturerFaultLibrary } from "./types";

export const emersonFaultLibrary: PlcManufacturerFaultLibrary = {
  manufacturer_id: "emerson",
  manufacturer_name: "Emerson",
  faults: [
    {
      id: "emerson-emerson-rx3i-ic695cpe100-no-power",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "IC695CPE100 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "power", "no power", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-stop-mode",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "IC695CPE100 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-unexpected-stop",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "IC695CPE100 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-watchdog",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Watchdog مال IC695CPE100 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "watchdog", "scan time", "cycle"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-scan-time",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Scan Time مال IC695CPE100 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "scan", "performance", "cycle time"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-cpu-overtemp",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "حرارة IC695CPE100 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "temperature", "overheat", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-battery",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Battery/Backup مال IC695CPE100 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "battery", "backup", "retain"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-memory",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Memory Error في IC695CPE100",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "memory", "card", "storage"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-retain",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "بيانات Retain مال IC695CPE100 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "retain", "memory", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-rtc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "ساعة RTC مال IC695CPE100 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-firmware",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Firmware مال IC695CPE100 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "firmware", "revision", "compatibility"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-project-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Project داخل IC695CPE100 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "project mismatch", "online offline", "compare"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-download-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Download إلى IC695CPE100 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "download", "transfer", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-upload-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Upload من IC695CPE100 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "upload", "access", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-password",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ IC695CPE100",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "password", "protection", "access"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-programming-connection",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ IC695CPE100",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "online", "connection", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-ip-conflict",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ IC695CPE100",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-network-link",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Ethernet Link مال IC695CPE100 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "ethernet", "link", "network"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-industrial-protocol",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا IC695CPE100 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-serial-comm",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا IC695CPE100 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-remote-io",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Remote I/O مرتبط بـ IC695CPE100 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "remote io", "distributed io", "offline"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-module-missing",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Module مفقود من تكوين IC695CPE100",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "module missing", "hardware configuration"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-module-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Module type/revision mismatch ويا IC695CPE100",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "module mismatch", "revision"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-backplane",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Backplane/Bus Fault مال IC695CPE100",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "backplane", "bus fault", "rack"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-digital-input",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Digital Input ما يقرا على IC695CPE100",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "digital input", "di", "sensor"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-digital-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "digital output", "do", "relay"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-input-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Input على IC695CPE100 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "input stuck", "di"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-output-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Output على IC695CPE100 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "output stuck", "welded", "force"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-analog-input-zero",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Analog Input على IC695CPE100 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-analog-input-max",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Analog Input على IC695CPE100 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "analog overrange", "ai"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-analog-noise",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Analog Reading على IC695CPE100 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "analog noise", "shield", "filter"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-analog-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Analog Output من IC695CPE100 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "analog output", "ao", "4-20ma"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-hsc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "High Speed Counter على IC695CPE100 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-encoder",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Encoder ويا IC695CPE100 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "encoder", "position", "a b z"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-force",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Force/Override فعال على IC695CPE100",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "force", "override", "test mode"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-interlock",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من IC695CPE100",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "interlock", "permissive", "logic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-safety",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ IC695CPE100 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-motion",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Motion/Axis command من IC695CPE100 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-pid",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "PID داخل IC695CPE100 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "pid", "tuning", "control loop"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-startup",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "IC695CPE100 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "startup", "power cycle", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-random-reset",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "IC695CPE100 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "reset", "reboot", "power dip"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-data-corruption",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "بيانات داخل IC695CPE100 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe100-diag-log",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE100",
      code: null,
      title_ar: "Diagnostic/Event log مال IC695CPE100 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE100",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE100", "diagnostic log", "event log", "history"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-no-power",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "IC695CPE115 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "power", "no power", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-stop-mode",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "IC695CPE115 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-unexpected-stop",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "IC695CPE115 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-watchdog",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Watchdog مال IC695CPE115 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "watchdog", "scan time", "cycle"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-scan-time",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Scan Time مال IC695CPE115 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "scan", "performance", "cycle time"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-cpu-overtemp",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "حرارة IC695CPE115 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "temperature", "overheat", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-battery",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Battery/Backup مال IC695CPE115 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "battery", "backup", "retain"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-memory",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Memory Error في IC695CPE115",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "memory", "card", "storage"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-retain",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "بيانات Retain مال IC695CPE115 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "retain", "memory", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-rtc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "ساعة RTC مال IC695CPE115 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-firmware",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Firmware مال IC695CPE115 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "firmware", "revision", "compatibility"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-project-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Project داخل IC695CPE115 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "project mismatch", "online offline", "compare"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-download-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Download إلى IC695CPE115 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "download", "transfer", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-upload-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Upload من IC695CPE115 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "upload", "access", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-password",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ IC695CPE115",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "password", "protection", "access"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-programming-connection",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ IC695CPE115",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "online", "connection", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-ip-conflict",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ IC695CPE115",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-network-link",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Ethernet Link مال IC695CPE115 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "ethernet", "link", "network"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-industrial-protocol",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا IC695CPE115 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-serial-comm",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا IC695CPE115 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-remote-io",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Remote I/O مرتبط بـ IC695CPE115 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "remote io", "distributed io", "offline"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-module-missing",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Module مفقود من تكوين IC695CPE115",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "module missing", "hardware configuration"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-module-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Module type/revision mismatch ويا IC695CPE115",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "module mismatch", "revision"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-backplane",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Backplane/Bus Fault مال IC695CPE115",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "backplane", "bus fault", "rack"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-digital-input",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Digital Input ما يقرا على IC695CPE115",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "digital input", "di", "sensor"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-digital-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "digital output", "do", "relay"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-input-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Input على IC695CPE115 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "input stuck", "di"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-output-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Output على IC695CPE115 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "output stuck", "welded", "force"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-analog-input-zero",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Analog Input على IC695CPE115 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-analog-input-max",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Analog Input على IC695CPE115 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "analog overrange", "ai"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-analog-noise",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Analog Reading على IC695CPE115 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "analog noise", "shield", "filter"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-analog-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Analog Output من IC695CPE115 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "analog output", "ao", "4-20ma"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-hsc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "High Speed Counter على IC695CPE115 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-encoder",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Encoder ويا IC695CPE115 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "encoder", "position", "a b z"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-force",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Force/Override فعال على IC695CPE115",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "force", "override", "test mode"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-interlock",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من IC695CPE115",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "interlock", "permissive", "logic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-safety",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ IC695CPE115 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-motion",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Motion/Axis command من IC695CPE115 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-pid",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "PID داخل IC695CPE115 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "pid", "tuning", "control loop"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-startup",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "IC695CPE115 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "startup", "power cycle", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-random-reset",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "IC695CPE115 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "reset", "reboot", "power dip"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-data-corruption",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "بيانات داخل IC695CPE115 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe115-diag-log",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE115",
      code: null,
      title_ar: "Diagnostic/Event log مال IC695CPE115 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE115",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE115", "diagnostic log", "event log", "history"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-no-power",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "IC695CPE302 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "power", "no power", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-stop-mode",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "IC695CPE302 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-unexpected-stop",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "IC695CPE302 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-watchdog",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Watchdog مال IC695CPE302 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "watchdog", "scan time", "cycle"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-scan-time",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Scan Time مال IC695CPE302 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "scan", "performance", "cycle time"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-cpu-overtemp",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "حرارة IC695CPE302 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "temperature", "overheat", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-battery",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Battery/Backup مال IC695CPE302 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "battery", "backup", "retain"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-memory",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Memory Error في IC695CPE302",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "memory", "card", "storage"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-retain",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "بيانات Retain مال IC695CPE302 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "retain", "memory", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-rtc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "ساعة RTC مال IC695CPE302 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-firmware",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Firmware مال IC695CPE302 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "firmware", "revision", "compatibility"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-project-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Project داخل IC695CPE302 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "project mismatch", "online offline", "compare"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-download-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Download إلى IC695CPE302 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "download", "transfer", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-upload-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Upload من IC695CPE302 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "upload", "access", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-password",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ IC695CPE302",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "password", "protection", "access"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-programming-connection",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ IC695CPE302",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "online", "connection", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-ip-conflict",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ IC695CPE302",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-network-link",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Ethernet Link مال IC695CPE302 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "ethernet", "link", "network"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-industrial-protocol",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا IC695CPE302 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-serial-comm",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا IC695CPE302 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-remote-io",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Remote I/O مرتبط بـ IC695CPE302 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "remote io", "distributed io", "offline"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-module-missing",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Module مفقود من تكوين IC695CPE302",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "module missing", "hardware configuration"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-module-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Module type/revision mismatch ويا IC695CPE302",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "module mismatch", "revision"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-backplane",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Backplane/Bus Fault مال IC695CPE302",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "backplane", "bus fault", "rack"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-digital-input",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Digital Input ما يقرا على IC695CPE302",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "digital input", "di", "sensor"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-digital-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "digital output", "do", "relay"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-input-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Input على IC695CPE302 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "input stuck", "di"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-output-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Output على IC695CPE302 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "output stuck", "welded", "force"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-analog-input-zero",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Analog Input على IC695CPE302 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-analog-input-max",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Analog Input على IC695CPE302 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "analog overrange", "ai"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-analog-noise",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Analog Reading على IC695CPE302 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "analog noise", "shield", "filter"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-analog-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Analog Output من IC695CPE302 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "analog output", "ao", "4-20ma"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-hsc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "High Speed Counter على IC695CPE302 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-encoder",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Encoder ويا IC695CPE302 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "encoder", "position", "a b z"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-force",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Force/Override فعال على IC695CPE302",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "force", "override", "test mode"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-interlock",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من IC695CPE302",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "interlock", "permissive", "logic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-safety",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ IC695CPE302 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-motion",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Motion/Axis command من IC695CPE302 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-pid",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "PID داخل IC695CPE302 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "pid", "tuning", "control loop"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-startup",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "IC695CPE302 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "startup", "power cycle", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-random-reset",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "IC695CPE302 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "reset", "reboot", "power dip"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-data-corruption",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "بيانات داخل IC695CPE302 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe302-diag-log",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE302",
      code: null,
      title_ar: "Diagnostic/Event log مال IC695CPE302 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE302",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE302", "diagnostic log", "event log", "history"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-no-power",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "IC695CPE305 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "power", "no power", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-stop-mode",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "IC695CPE305 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-unexpected-stop",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "IC695CPE305 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-watchdog",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Watchdog مال IC695CPE305 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "watchdog", "scan time", "cycle"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-scan-time",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Scan Time مال IC695CPE305 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "scan", "performance", "cycle time"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-cpu-overtemp",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "حرارة IC695CPE305 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "temperature", "overheat", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-battery",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Battery/Backup مال IC695CPE305 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "battery", "backup", "retain"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-memory",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Memory Error في IC695CPE305",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "memory", "card", "storage"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-retain",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "بيانات Retain مال IC695CPE305 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "retain", "memory", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-rtc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "ساعة RTC مال IC695CPE305 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-firmware",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Firmware مال IC695CPE305 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "firmware", "revision", "compatibility"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-project-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Project داخل IC695CPE305 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "project mismatch", "online offline", "compare"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-download-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Download إلى IC695CPE305 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "download", "transfer", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-upload-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Upload من IC695CPE305 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "upload", "access", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-password",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ IC695CPE305",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "password", "protection", "access"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-programming-connection",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ IC695CPE305",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "online", "connection", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-ip-conflict",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ IC695CPE305",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-network-link",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Ethernet Link مال IC695CPE305 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "ethernet", "link", "network"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-industrial-protocol",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا IC695CPE305 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-serial-comm",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا IC695CPE305 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-remote-io",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Remote I/O مرتبط بـ IC695CPE305 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "remote io", "distributed io", "offline"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-module-missing",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Module مفقود من تكوين IC695CPE305",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "module missing", "hardware configuration"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-module-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Module type/revision mismatch ويا IC695CPE305",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "module mismatch", "revision"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-backplane",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Backplane/Bus Fault مال IC695CPE305",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "backplane", "bus fault", "rack"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-digital-input",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Digital Input ما يقرا على IC695CPE305",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "digital input", "di", "sensor"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-digital-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "digital output", "do", "relay"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-input-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Input على IC695CPE305 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "input stuck", "di"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-output-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Output على IC695CPE305 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "output stuck", "welded", "force"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-analog-input-zero",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Analog Input على IC695CPE305 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-analog-input-max",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Analog Input على IC695CPE305 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "analog overrange", "ai"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-analog-noise",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Analog Reading على IC695CPE305 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "analog noise", "shield", "filter"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-analog-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Analog Output من IC695CPE305 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "analog output", "ao", "4-20ma"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-hsc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "High Speed Counter على IC695CPE305 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-encoder",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Encoder ويا IC695CPE305 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "encoder", "position", "a b z"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-force",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Force/Override فعال على IC695CPE305",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "force", "override", "test mode"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-interlock",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من IC695CPE305",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "interlock", "permissive", "logic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-safety",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ IC695CPE305 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-motion",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Motion/Axis command من IC695CPE305 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-pid",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "PID داخل IC695CPE305 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "pid", "tuning", "control loop"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-startup",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "IC695CPE305 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "startup", "power cycle", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-random-reset",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "IC695CPE305 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "reset", "reboot", "power dip"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-data-corruption",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "بيانات داخل IC695CPE305 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe305-diag-log",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE305",
      code: null,
      title_ar: "Diagnostic/Event log مال IC695CPE305 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE305",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE305", "diagnostic log", "event log", "history"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-no-power",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "IC695CPE310 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "power", "no power", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-stop-mode",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "IC695CPE310 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-unexpected-stop",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "IC695CPE310 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-watchdog",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Watchdog مال IC695CPE310 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "watchdog", "scan time", "cycle"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-scan-time",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Scan Time مال IC695CPE310 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "scan", "performance", "cycle time"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-cpu-overtemp",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "حرارة IC695CPE310 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "temperature", "overheat", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-battery",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Battery/Backup مال IC695CPE310 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "battery", "backup", "retain"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-memory",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Memory Error في IC695CPE310",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "memory", "card", "storage"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-retain",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "بيانات Retain مال IC695CPE310 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "retain", "memory", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-rtc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "ساعة RTC مال IC695CPE310 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-firmware",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Firmware مال IC695CPE310 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "firmware", "revision", "compatibility"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-project-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Project داخل IC695CPE310 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "project mismatch", "online offline", "compare"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-download-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Download إلى IC695CPE310 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "download", "transfer", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-upload-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Upload من IC695CPE310 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "upload", "access", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-password",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ IC695CPE310",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "password", "protection", "access"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-programming-connection",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ IC695CPE310",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "online", "connection", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-ip-conflict",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ IC695CPE310",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-network-link",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Ethernet Link مال IC695CPE310 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "ethernet", "link", "network"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-industrial-protocol",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا IC695CPE310 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-serial-comm",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا IC695CPE310 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-remote-io",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Remote I/O مرتبط بـ IC695CPE310 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "remote io", "distributed io", "offline"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-module-missing",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Module مفقود من تكوين IC695CPE310",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "module missing", "hardware configuration"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-module-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Module type/revision mismatch ويا IC695CPE310",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "module mismatch", "revision"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-backplane",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Backplane/Bus Fault مال IC695CPE310",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "backplane", "bus fault", "rack"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-digital-input",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Digital Input ما يقرا على IC695CPE310",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "digital input", "di", "sensor"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-digital-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "digital output", "do", "relay"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-input-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Input على IC695CPE310 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "input stuck", "di"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-output-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Output على IC695CPE310 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "output stuck", "welded", "force"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-analog-input-zero",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Analog Input على IC695CPE310 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-analog-input-max",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Analog Input على IC695CPE310 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "analog overrange", "ai"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-analog-noise",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Analog Reading على IC695CPE310 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "analog noise", "shield", "filter"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-analog-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Analog Output من IC695CPE310 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "analog output", "ao", "4-20ma"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-hsc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "High Speed Counter على IC695CPE310 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-encoder",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Encoder ويا IC695CPE310 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "encoder", "position", "a b z"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-force",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Force/Override فعال على IC695CPE310",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "force", "override", "test mode"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-interlock",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من IC695CPE310",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "interlock", "permissive", "logic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-safety",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ IC695CPE310 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-motion",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Motion/Axis command من IC695CPE310 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-pid",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "PID داخل IC695CPE310 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "pid", "tuning", "control loop"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-startup",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "IC695CPE310 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "startup", "power cycle", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-random-reset",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "IC695CPE310 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "reset", "reboot", "power dip"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-data-corruption",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "بيانات داخل IC695CPE310 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe310-diag-log",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE310",
      code: null,
      title_ar: "Diagnostic/Event log مال IC695CPE310 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE310",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE310", "diagnostic log", "event log", "history"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-no-power",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "IC695CPE330 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "power", "no power", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-stop-mode",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "IC695CPE330 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-unexpected-stop",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "IC695CPE330 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-watchdog",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Watchdog مال IC695CPE330 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "watchdog", "scan time", "cycle"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-scan-time",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Scan Time مال IC695CPE330 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "scan", "performance", "cycle time"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-cpu-overtemp",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "حرارة IC695CPE330 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "temperature", "overheat", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-battery",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Battery/Backup مال IC695CPE330 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "battery", "backup", "retain"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-memory",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Memory Error في IC695CPE330",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "memory", "card", "storage"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-retain",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "بيانات Retain مال IC695CPE330 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "retain", "memory", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-rtc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "ساعة RTC مال IC695CPE330 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-firmware",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Firmware مال IC695CPE330 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "firmware", "revision", "compatibility"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-project-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Project داخل IC695CPE330 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "project mismatch", "online offline", "compare"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-download-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Download إلى IC695CPE330 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "download", "transfer", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-upload-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Upload من IC695CPE330 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "upload", "access", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-password",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ IC695CPE330",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "password", "protection", "access"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-programming-connection",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ IC695CPE330",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "online", "connection", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-ip-conflict",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ IC695CPE330",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-network-link",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Ethernet Link مال IC695CPE330 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "ethernet", "link", "network"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-industrial-protocol",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا IC695CPE330 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-serial-comm",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا IC695CPE330 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-remote-io",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Remote I/O مرتبط بـ IC695CPE330 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "remote io", "distributed io", "offline"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-module-missing",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Module مفقود من تكوين IC695CPE330",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "module missing", "hardware configuration"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-module-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Module type/revision mismatch ويا IC695CPE330",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "module mismatch", "revision"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-backplane",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Backplane/Bus Fault مال IC695CPE330",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "backplane", "bus fault", "rack"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-digital-input",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Digital Input ما يقرا على IC695CPE330",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "digital input", "di", "sensor"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-digital-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "digital output", "do", "relay"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-input-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Input على IC695CPE330 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "input stuck", "di"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-output-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Output على IC695CPE330 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "output stuck", "welded", "force"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-analog-input-zero",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Analog Input على IC695CPE330 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-analog-input-max",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Analog Input على IC695CPE330 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "analog overrange", "ai"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-analog-noise",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Analog Reading على IC695CPE330 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "analog noise", "shield", "filter"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-analog-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Analog Output من IC695CPE330 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "analog output", "ao", "4-20ma"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-hsc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "High Speed Counter على IC695CPE330 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-encoder",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Encoder ويا IC695CPE330 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "encoder", "position", "a b z"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-force",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Force/Override فعال على IC695CPE330",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "force", "override", "test mode"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-interlock",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من IC695CPE330",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "interlock", "permissive", "logic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-safety",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ IC695CPE330 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-motion",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Motion/Axis command من IC695CPE330 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-pid",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "PID داخل IC695CPE330 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "pid", "tuning", "control loop"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-startup",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "IC695CPE330 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "startup", "power cycle", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-random-reset",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "IC695CPE330 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "reset", "reboot", "power dip"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-data-corruption",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "بيانات داخل IC695CPE330 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe330-diag-log",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE330",
      code: null,
      title_ar: "Diagnostic/Event log مال IC695CPE330 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE330",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE330", "diagnostic log", "event log", "history"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-no-power",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "IC695CPE400 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "power", "no power", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-stop-mode",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "IC695CPE400 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-unexpected-stop",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "IC695CPE400 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-watchdog",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Watchdog مال IC695CPE400 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "watchdog", "scan time", "cycle"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-scan-time",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Scan Time مال IC695CPE400 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "scan", "performance", "cycle time"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-cpu-overtemp",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "حرارة IC695CPE400 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "temperature", "overheat", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-battery",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Battery/Backup مال IC695CPE400 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "battery", "backup", "retain"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-memory",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Memory Error في IC695CPE400",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "memory", "card", "storage"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-retain",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "بيانات Retain مال IC695CPE400 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "retain", "memory", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-rtc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "ساعة RTC مال IC695CPE400 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-firmware",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Firmware مال IC695CPE400 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "firmware", "revision", "compatibility"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-project-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Project داخل IC695CPE400 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "project mismatch", "online offline", "compare"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-download-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Download إلى IC695CPE400 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "download", "transfer", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-upload-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Upload من IC695CPE400 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "upload", "access", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-password",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ IC695CPE400",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "password", "protection", "access"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-programming-connection",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ IC695CPE400",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "online", "connection", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-ip-conflict",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ IC695CPE400",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-network-link",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Ethernet Link مال IC695CPE400 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "ethernet", "link", "network"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-industrial-protocol",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا IC695CPE400 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-serial-comm",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا IC695CPE400 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-remote-io",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Remote I/O مرتبط بـ IC695CPE400 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "remote io", "distributed io", "offline"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-module-missing",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Module مفقود من تكوين IC695CPE400",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "module missing", "hardware configuration"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-module-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Module type/revision mismatch ويا IC695CPE400",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "module mismatch", "revision"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-backplane",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Backplane/Bus Fault مال IC695CPE400",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "backplane", "bus fault", "rack"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-digital-input",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Digital Input ما يقرا على IC695CPE400",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "digital input", "di", "sensor"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-digital-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "digital output", "do", "relay"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-input-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Input على IC695CPE400 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "input stuck", "di"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-output-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Output على IC695CPE400 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "output stuck", "welded", "force"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-analog-input-zero",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Analog Input على IC695CPE400 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-analog-input-max",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Analog Input على IC695CPE400 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "analog overrange", "ai"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-analog-noise",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Analog Reading على IC695CPE400 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "analog noise", "shield", "filter"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-analog-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Analog Output من IC695CPE400 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "analog output", "ao", "4-20ma"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-hsc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "High Speed Counter على IC695CPE400 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-encoder",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Encoder ويا IC695CPE400 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "encoder", "position", "a b z"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-force",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Force/Override فعال على IC695CPE400",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "force", "override", "test mode"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-interlock",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من IC695CPE400",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "interlock", "permissive", "logic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-safety",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ IC695CPE400 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-motion",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Motion/Axis command من IC695CPE400 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-pid",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "PID داخل IC695CPE400 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "pid", "tuning", "control loop"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-startup",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "IC695CPE400 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "startup", "power cycle", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-random-reset",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "IC695CPE400 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "reset", "reboot", "power dip"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-data-corruption",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "بيانات داخل IC695CPE400 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpe400-diag-log",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPE400",
      code: null,
      title_ar: "Diagnostic/Event log مال IC695CPE400 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPE400",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPE400", "diagnostic log", "event log", "history"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-no-power",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "IC695CPL410 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "power", "no power", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-stop-mode",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "IC695CPL410 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-unexpected-stop",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "IC695CPL410 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-watchdog",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Watchdog مال IC695CPL410 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "watchdog", "scan time", "cycle"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-scan-time",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Scan Time مال IC695CPL410 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "scan", "performance", "cycle time"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-cpu-overtemp",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "حرارة IC695CPL410 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "temperature", "overheat", "cpu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-battery",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Battery/Backup مال IC695CPL410 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "battery", "backup", "retain"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-memory",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Memory Error في IC695CPL410",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "memory", "card", "storage"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-retain",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "بيانات Retain مال IC695CPL410 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "retain", "memory", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-rtc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "ساعة RTC مال IC695CPL410 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-firmware",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Firmware مال IC695CPL410 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "firmware", "revision", "compatibility"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-project-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Project داخل IC695CPL410 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "project mismatch", "online offline", "compare"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-download-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Download إلى IC695CPL410 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "download", "transfer", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-upload-fail",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Upload من IC695CPL410 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "upload", "access", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-password",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ IC695CPL410",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "password", "protection", "access"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-programming-connection",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ IC695CPL410",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: PAC Machine Edition.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "online", "connection", "programming"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-ip-conflict",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ IC695CPL410",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-network-link",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Ethernet Link مال IC695CPL410 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "ethernet", "link", "network"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-industrial-protocol",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا IC695CPL410 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-serial-comm",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا IC695CPL410 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-remote-io",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Remote I/O مرتبط بـ IC695CPL410 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "remote io", "distributed io", "offline"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-module-missing",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Module مفقود من تكوين IC695CPL410",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "module missing", "hardware configuration"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-module-mismatch",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Module type/revision mismatch ويا IC695CPL410",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "module mismatch", "revision"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-backplane",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Backplane/Bus Fault مال IC695CPL410",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "backplane", "bus fault", "rack"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-digital-input",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Digital Input ما يقرا على IC695CPL410",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "digital input", "di", "sensor"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-digital-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "digital output", "do", "relay"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-input-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Input على IC695CPL410 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "input stuck", "di"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-output-stuck",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Output على IC695CPL410 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "output stuck", "welded", "force"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-analog-input-zero",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Analog Input على IC695CPL410 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-analog-input-max",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Analog Input على IC695CPL410 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "analog overrange", "ai"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-analog-noise",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Analog Reading على IC695CPL410 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "analog noise", "shield", "filter"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-analog-output",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Analog Output من IC695CPL410 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "analog output", "ao", "4-20ma"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-hsc",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "High Speed Counter على IC695CPL410 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-encoder",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Encoder ويا IC695CPL410 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "encoder", "position", "a b z"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-force",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Force/Override فعال على IC695CPL410",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "force", "override", "test mode"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-interlock",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من IC695CPL410",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "interlock", "permissive", "logic"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-safety",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ IC695CPL410 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-motion",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Motion/Axis command من IC695CPL410 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-pid",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "PID داخل IC695CPL410 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "pid", "tuning", "control loop"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-startup",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "IC695CPL410 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "startup", "power cycle", "restart"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-random-reset",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "IC695CPL410 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "reset", "reboot", "power dip"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-data-corruption",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "بيانات داخل IC695CPL410 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "emerson-emerson-rx3i-ic695cpl410-diag-log",
      manufacturer_id: "emerson",
      series_id: "emerson-rx3i",
      model: "IC695CPL410",
      code: null,
      title_ar: "Diagnostic/Event log مال IC695CPL410 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "IC695CPL410",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Emerson", "PACSystems RX3i / RX3i Edge Controller", "IC695CPL410", "diagnostic log", "event log", "history"],
    },
  ],
};
